import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useRef } from "react";
import { useSelector } from "react-redux";
import { PublicSearch } from "~/components/Search/PublicSearch";
import { PublicBoardHeaderActions } from "~/components/Shared/HeaderBar/PublicBoardHeaderActions";
import { BoardSidebar } from "~/components/v2/components/board/BoardSidebar";
import { PublicBoardBottomBar } from "~/components/v2/components/board/PublicBoardBottomBar";
import { ScrollElementContextConsumer, ScrollElementContextProvider } from "~/components/v2/components/shared/scroll/ScrollElementContextProvider";
import { PublicBoardsAndAssetsSelectionBar } from "~/components/v2/components/shared/selectionBar/PublicBoardsAndAssetsSelectionBar";
import { PublicDefaultLayout } from "~/components/v2/layouts/PublicDefaultLayout";
import { ScrollElementProvider } from "~/providers/ScrollElementProvider";
import { centralizedBoardSelector } from "~/store/centralizedBoard/selectors";
export const PublicBoardLayout = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const scrollElementRef = useRef(null);
    const board = useSelector(centralizedBoardSelector);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(ScrollElementProvider, {
            scrollElementRef: scrollElementRef,
            children: [
                /*#__PURE__*/ _jsx(ScrollElementContextProvider, {
                    children: /*#__PURE__*/ _jsx(ScrollElementContextConsumer, {
                        children: (param)=>{
                            let { setScrollElement } = param;
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "relative grow overflow-hidden rounded-12 bg-grey-1",
                                children: [
                                    /*#__PURE__*/ _jsx("main", {
                                        className: "h-full overflow-y-auto pb-12",
                                        ref: (ref)=>{
                                            scrollElementRef.current = ref;
                                            setScrollElement(ref);
                                        },
                                        children: children
                                    }),
                                    board && /*#__PURE__*/ _jsx("div", {
                                        className: "absolute inset-x-0 bottom-0 overflow-hidden rounded-b-12",
                                        children: /*#__PURE__*/ _jsx(PublicBoardBottomBar, {})
                                    })
                                ]
                            });
                        }
                    })
                }),
                board && /*#__PURE__*/ _jsx(PublicBoardsAndAssetsSelectionBar, {}),
                /*#__PURE__*/ _jsx(BoardSidebar, {})
            ]
        })
    });
});
PublicBoardLayout.displayName = "PublicBoardLayout";
export const getPublicBoardLayout = (page)=>/*#__PURE__*/ _jsx(PublicDefaultLayout, {
        children: /*#__PURE__*/ _jsx(PublicBoardLayout, {
            children: page
        })
    });
export const getPublicBoardLayoutWithProviders = (page, initialData, shortId)=>/*#__PURE__*/ _jsx(PublicDefaultLayout, {
        initialData: initialData,
        shortId: shortId,
        Search: /*#__PURE__*/ _jsx(PublicSearch, {
            onCloseClick: ()=>undefined
        }),
        headerActions: (initialData === null || initialData === void 0 ? void 0 : initialData.board) ? /*#__PURE__*/ _jsx(PublicBoardHeaderActions, {
            board: initialData.board
        }) : undefined,
        children: /*#__PURE__*/ _jsx(PublicBoardLayout, {
            children: page
        })
    });
